module.exports = __webpack_public_path__ + "img/instagram.4c8f827a.svg";